import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/KebunPRT.css";
import axios from "axios";

const KebunPRP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState(""); 

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/view_panen",
          {
            headers: {
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );

        if (response.data.panens) {
          setTableData(response.data.panens);
        }
      } catch (error) {
        console.error("Error fetching panen data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  const handleDetail = (id) => {
    navigate(`/kebunPRP/detail/${id}`);
  };

  const handleBack = () => {
    navigate("/KebunP");
  };

  const handleFilterChange = (status) => {
    setFilterStatus(status);
  };

  const filteredTableData = filterStatus
    ? tableData.filter(
        (item) =>
          item.status &&
          item.status.toLowerCase() === filterStatus.toLowerCase()
      )
    : tableData;

  const getStatusCount = (status) => {
    return tableData.filter(
      (item) => item.status && item.status.toLowerCase() === status.toLowerCase()
    ).length;
  };

  const sortedTableData = [...filteredTableData].sort((a, b) => b.id - a.id);

  // Helper Warna Status Validasi
  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s === "approved" || s === "disetujui") {
      return <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill border border-success-subtle fw-semibold">Approved</span>;
    }
    if (s === "rejected" || s === "ditolak") {
      return <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill border border-danger-subtle fw-semibold">Rejected</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis px-3 py-2 rounded-pill border border-warning-subtle fw-semibold">Pending</span>;
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/kebun")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/kebun" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/kebun" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/KebunP")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.includes("/kebunPRP") || location.pathname === "/KebunP"
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px", filter: location.pathname.includes("/kebunPRP") || location.pathname === "/KebunP" ? "brightness(0) invert(1)" : "none" }} /> Petani
            </div>
            <div
              onClick={() => navigate("/KebunL")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/KebunL" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Harvest" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/KebunL" ? "brightness(0) invert(1)" : "none" }} /> Logistik
            </div>
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/pabrik" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/factory.png" alt="Factory" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/pabrik" ? "brightness(0) invert(1)" : "none" }} /> Pabrik
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Rencana Panen</h2>
            <button className="btn kembali-button px-4" onClick={handleBack}>
              Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Card */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            
            {/* Modern Filter Section */}
            <div className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4 pb-3 border-bottom">
              <span className="fw-bold text-muted text-nowrap">Filter Status:</span>
              <div className="d-flex flex-wrap gap-2">
                <button
                  className={`btn rounded-pill px-4 fw-medium ${filterStatus === "approved" ? "btn-success shadow-sm" : "btn-outline-success"}`}
                  onClick={() => handleFilterChange("approved")}
                >
                  Approved ({getStatusCount("approved")})
                </button>
                <button
                  className={`btn rounded-pill px-4 fw-medium ${filterStatus === "pending" ? "btn-warning shadow-sm" : "btn-outline-warning text-dark"}`}
                  onClick={() => handleFilterChange("pending")}
                >
                  Pending ({getStatusCount("pending")})
                </button>
                <button
                  className={`btn rounded-pill px-4 fw-medium ${filterStatus === "rejected" ? "btn-danger shadow-sm" : "btn-outline-danger"}`}
                  onClick={() => handleFilterChange("rejected")}
                >
                  Rejected ({getStatusCount("rejected")})
                </button>
                <div className="vr d-none d-md-block mx-1 text-muted"></div>
                <button
                  className={`btn rounded-pill px-4 fw-medium ${filterStatus === "" ? "btn-secondary shadow-sm" : "btn-outline-secondary"}`}
                  onClick={() => handleFilterChange("")}
                >
                  Tampilkan Semua
                </button>
              </div>
            </div>

            {/* Table Area */}
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data rencana panen...</p>
              </div>
            ) : (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle" style={{ minWidth: "1000px" }}>
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                      <th className="text-center py-3" style={{ width: "80px" }}>ID</th>
                      <th className="py-3">Nama Petani</th>
                      <th className="text-center py-3">Tanggal Panen</th>
                      <th className="py-3" style={{ minWidth: "180px" }}>Resi Pengiriman</th>
                      <th className="text-center py-3">Status</th>
                      <th className="text-center py-3" style={{ width: "160px", borderTopRightRadius: "10px" }}>Aksi</th>
                    </tr>
                  </thead>
                  
                  {/* PENAMBAHAN KEY UNTUK ANTI-CRASH DATATABLES */}
                  <tbody key={filterStatus}>
                    {sortedTableData.length > 0 ? (
                      sortedTableData.map((item, index) => (
                        <tr key={`panen-${item.id || index}`}>
                          <td className="text-center fw-bold text-muted">
                            <span>{index + 1}</span>
                          </td>
                          <td className="text-center font-monospace fw-bold text-secondary">
                            <span>#{item.id}</span>
                          </td>
                          <td className="fw-semibold text-dark text-capitalize text-nowrap">
                            <span>{item.nama || "-"}</span>
                          </td>
                          <td className="text-center text-muted text-nowrap">
                            <span>{item.tanggal_panen || "-"}</span>
                          </td>
                          <td className="text-nowrap">
                            {/* Resi Pengiriman: Ukuran font disesuaikan agar lebih besar dan mudah dibaca */}
                            {Array.isArray(item.resi_pengiriman) && item.resi_pengiriman.length > 0 ? (
                              <div className="d-flex flex-column gap-2 align-items-start">
                                {item.resi_pengiriman.map((resi, idx) => (
                                  <span 
                                    key={idx} 
                                    className="bg-light text-dark border rounded px-3 py-1 fw-semibold font-monospace shadow-sm"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    {resi || "-"}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              <span className="fst-italic text-muted">-</span>
                            )}
                          </td>
                          <td className="text-center text-nowrap">
                            {getStatusBadge(item.status)}
                          </td>
                          <td className="text-center">
                            {/* Tombol Hapus dihilangkan, hanya menyisakan tombol Detail */}
                            <button
                              className="btn btn-outline-primary btn-sm rounded-pill px-4 fw-medium text-nowrap shadow-sm"
                              onClick={() => handleDetail(item.id)}
                            >
                              Detail
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        {/* colSpan diubah jadi 7 karena kolom Alamat sudah dihapus */}
                        <td colSpan="7" className="text-center py-5 text-muted">
                          <i className="fa fa-folder-open mb-2 fs-3 opacity-50"></i>
                          <br />
                          <span>Data tidak ditemukan untuk status ini.</span>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            
            {/* Navigasi Placeholder UI */}
            <nav className="mt-4">
              <ul className="pagination justify-content-end mb-0">
                <li className="page-item disabled">
                  <button className="page-link shadow-none rounded-start-pill">Previous</button>
                </li>
                <li className="page-item active">
                  <button className="page-link shadow-none">1</button>
                </li>
                <li className="page-item disabled">
                  <button className="page-link shadow-none rounded-end-pill">Next</button>
                </li>
              </ul>
            </nav>

          </div>
        </div>
      </div>
    </div>
  );
};

export default KebunPRP;